import { Version } from '@feedyou/utils'

import { FeedbotThunk } from '../../../store/types'
import { dialog } from '../../../lib/bootbox'
import { loadedBotVersionSelector } from '../../../store/flow/selectors/loadedBotVersionSelector'
import { navigateToEnv } from './navigateToEnv'
import { RootState } from '../../../reducers'
import { removePrivilegedActions } from '../utils/bootbox'
import { currentBotMetadataSelector } from '../selectors/currentBotMetadataSelector'
import { expandedUserPermissionsSelector } from '../../../store/user/selectors'
import { endpointHelpers } from '../endpointHelpers'
import { environmentGroupForCurrentBotSelector } from '@features/serverBots/selectors/environmentGroupForCurrentBotSelector'
import { EnvironmentGroupDescriptor } from '@features/serverBots/types'

// This is kinda stupid, but also good enough and much easier than anything else.
// We do not really care that this popup can only display once per page load.
// We need this limitation so it does not re-trigger again once we confirm it
let alreadyOpen = false

export const promptForDisabledDevResolution = (): FeedbotThunk => (dispatch, getState) => {
  const currentVersion = loadedBotVersionSelector(getState())!

  if (!currentVersion || alreadyOpen) {
    return
  }

  if (!isOnDisabledDevBotSelector(getState())) {
    return
  }

  alreadyOpen = true

  const canCopywrite = !!expandedUserPermissionsSelector(getState()).copywrite
  const goToProd = () => dispatch(navigateToEnv('prod'))
  const reenableTest = () => dispatch(endpointHelpers.moveProdToTest.initiate())

  promptForEnablingDevEnvironment(
    currentVersion,
    canCopywrite,
    goToProd,
    reenableTest,
    environmentGroupForCurrentBotSelector(getState())
  )
}

async function promptForEnablingDevEnvironment(
  currentBotVersion: string,
  canCopywrite: boolean,
  goToProduction: () => void,
  reenableTest: () => void,
  { prodName, testName }: EnvironmentGroupDescriptor
) {
  const basicOptions = {
    title: `${testName} environment disabled`,
    message: `There is no active version in ${testName} environment, do you want to create there new major version ${Version.incrementMajor(
      currentBotVersion
    )}?`,
    size: 'medium',
    closeButton: false,
    buttons: {
      viewOnly: {
        label: 'View only',
        callback: () => {}
      },
      close: {
        label: `Go to ${prodName}`,
        callback: () => goToProduction(),
        className: 'btn-secondary'
      },
      ok: {
        label: `Enable ${testName}`,
        callback: () => reenableTest(),
        className: 'btn-positive'
      }
    }
  }

  const options = canCopywrite ? basicOptions : removePrivilegedActions(basicOptions, testName)
  dialog(options)
}

export const isOnDisabledDevBotSelector = (state: RootState) => {
  const metadata = currentBotMetadataSelector(state)

  return (
    !!metadata && // I <3 PRETTIER
    metadata.environmentType === 'test' &&
    !metadata.environmentEnabledStatus
  )
}
